import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { oss, isSSR } from '../../scripts/utils';
import './index.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { filter } from 'lodash';

export default function BrandWall({ data }) {
  const { width } = useWindowDimensions();

  const getSlidesToShow = () => {
    if (!width) return 6;
    if (width >= 1400) return 6;
    if (width >= 1200) return 5;
    if (width >= 900) return 4;
    if (width < 375) return 2;
    return 3;
  };
  const settings = {
    infinite: true,
    swipe: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    slidesToShow: getSlidesToShow(),
    speed: 2000,
    cssEase: 'linear',
    rows: 1,
    arrows: false,
    centerPadding: '0px'
  };
  const filterData = filter(data, (d) => !!d.customerLogo) ?? [];
  const chunkSize = Math.ceil(filterData.length / 3);
  const list = [
    filterData.slice(0, chunkSize),
    filterData.slice(chunkSize, chunkSize * 2),
    filterData.slice(chunkSize * 2)
  ];

  // 在 SSR 环境中只渲染前几个品牌，避免 Slider 组件问题
  if (isSSR) {
    return (
      <div className={classnames('brands-wall-wrapper')}>
        <div className="brands-wall">
          <div className="brands-grid">
            {filterData.slice(0, 6).map((brand, i) => (
              <div key={`brand-wall-${i}`} className={classnames('brands-item-wrap')}>
                <Link to={`/case-detail/${brand.id}`}>
                  <img
                    src={oss(brand.customerLogo, 240, 80, 'lfit')}
                    alt={brand.customerName}
                    title={brand.customerName}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return <div className={classnames('brands-wall-wrapper')}>
    <div className="brands-wall">
      {list.map((items, index) => (
        <div 
          key={index} 
          className={`slick-row ${index % 2 === 0 ? 'slick-row-even' : 'slick-row-odd'}`}
        >
          <Slider
            {...settings}
            rtl={index % 2 === 0} // 偶数行启用RTL反向滚动
          >
            {items.map((brand, i) => (
              <div key={`brand-wall-${i}`} className={classnames('brands-item-wrap')}>
                <Link to={`/case-detail/${brand.id}`}>
                  <img
                    src={oss(brand.customerLogo, 240, 80, 'lfit')}
                    alt={brand.customerName}
                    title={brand.customerName}
                  />
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      ))}
    </div>
  </div>
  
  // return (
  //   <div className={classnames('brands-wall-wrapper')}>
  //     <div className="brands-wall">
  //       <Slider {...settings}>
  //         {filterData.map((brand, i) => (
  //           <div key={`brand-wall-${i}`} className={classnames('brands-item-wrap')}>
  //             <Link to={`/case-detail/${brand.id}`}>
  //               <img
  //                 src={oss(brand.customerLogo, 240, 80, 'lfit')}
  //                 alt={brand.customerName}
  //                 title={brand.customerName}
  //               />
  //             </Link>
  //           </div>
  //         ))}
  //       </Slider>
  //       <div className="mobile-wall-page">
  //         <CursorPagination
  //           cols={3}
  //           count={Math.ceil(filterData.length / rows / getSlidesToShow())}
  //           activeIndex={index}
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
}
